export class TipoMovimentacaoCnj {
    id = 0;
    codItem = '';
    codItemPai = '';
    tipoItem = '';
    nome = '';
    situacao = 0;
    ativo = false;
}